import { ButtonProps, Image, Button } from 'antd';
import styled from 'styled-components';

export const StyledImage = styled(Image)`
  display: flex;

  &.ant-image-img {
    width: 18px;
  }
`;

export const StyledButton = styled(Button)<ButtonProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: min(320px, 100%);
  height: 48px;
  background: #ffffff !important;
  border: 1px solid rgba(255, 255, 255, 0.9) !important;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  color: rgba(10, 10, 54, 0.88) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
  transition: background 0.15s ease, border-color 0.15s ease, transform 0.05s ease;

  &.ant-btn-default:not(:disabled):hover {
    background: #f7f8fc !important;
    border-color: #ffffff !important;
    color: rgba(10, 10, 54, 1) !important;
  }

  &.ant-btn-default:not(:disabled):active {
    transform: translateY(1px);
  }
`;
